import { Injectable, EventEmitter } from '@angular/core';
import { RESTServiceBase, CacheTypes } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { KPIDescriptor } from './model/kpi.descriptor';
import { View } from '../../common/model/view';
import { SignalRService } from '../../services/signalr.service';
import { Subscription } from 'rxjs';

const KpiKeysPublic: string[] = [
  'None',
  'NyitottAdatszolgáltatás',
  'None',
  'None',
  'None',
  'None',
  'None',
  'EldöntendőMódosításiKérelem',
  'EldöntendőAdategyeztetés',
  'Ügyfélkapcsolatok',
  'None',
  'Közlemények',
  'BetöltésAlattAdatszolgáltatás',
];

const KpiKeysAdmin: string[] = [
  'None',
  'None',
  'None',
  'None',
  'EllenörzésreVáróAdatszolgáltatás',
  'EllenörzöttÉsHibásAdatszolgáltatás',
  'EllenörzöttÉsHibátlanAdatszolgáltatás',
  'EldöntendőMódosításiKérelem',
  'EldöntendőAdategyeztetés',
  'Ügyfélkapcsolatok',
  'ÜgyfélkapcsolatokKijelölésre',
  'Közlemények',
  'BetöltésAlattAdatszolgáltatás',
];


@Injectable()
export class KPIService extends RESTServiceBase {
  private kpiValuesSubscription: Subscription;

  public updated: EventEmitter<KPIDescriptor[]> = new EventEmitter(true);
  public updatedPending: EventEmitter<boolean> = new EventEmitter(true);
  private pendingKpis: any = {};

  constructor(
    private authService: AuthService,
    private signalRService: SignalRService,
    config: AppConfig
  ) {
    super(
      'v1',
      'KPIManagement',
      authService,
      config.KPIConfig
    );

    signalRService.ConnectionEvents.subscribe(ce => {
      if (this.kpiValuesSubscription) {
        this.kpiValuesSubscription.unsubscribe();
        this.kpiValuesSubscription = undefined;
      }

      if (ce) {
        this.kpiValuesSubscription = signalRService.addPublishKpiValuesListener().subscribe(mm => { 
          const keys = authService.hasAccess('Administrative',undefined) ? KpiKeysAdmin : KpiKeysPublic;
          const mapped = keys.map((v,i) => new KPIDescriptor( { id: '', indicatorType: v, count: mm[i], profileId: '', href:'', modified: undefined, deleted: undefined } ));
          this.updated.emit(mapped);
      });
      }
    }); 
  }

  public getIndicators(profileId: string): Promise<List<KPIDescriptor>> {
    const v = new View();
    v.addOrUpdateFilter('profileId', profileId);
    v.Limit = 20;
    return super.get<List<KPIDescriptor>>(undefined, v, undefined, CacheTypes.ShortPrivateCache);
  }

  public indicatePending(kpi: string) {
    this.pendingKpis[kpi] = true;
    this.updatedPending.emit(true);
  }

  public clearPendingKpi(kpi: string) {
    this.pendingKpis[kpi] = undefined;
  }

  public getPendingKpis(): any {
    return this.pendingKpis;
  }

  public async update(profileId: string) {
    if (this.authService.isAuthorized && !this.signalRService.IsConnected) {
      const result = await this.getIndicators(profileId);

      const mapped = result.value.map(r => KPIDescriptor.Map(r));

      this.updated.emit(mapped);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/kpi/kpi.service.ts